<style scoped>
.regra {
  position: relative;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
  background: #fff;
}

.regra + .regra {
  margin-top: 24px;
}

.regra + .regra::before {
  position: absolute;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  content: "OU";
  top: -20px;
  font-size: 11px;
  font-weight: 700;
  color: #888;
  background: #f4f5f7;
  padding: 2px 12px;
  border-radius: 10px;
  letter-spacing: 0.5px;
}

.regra-and + .regra-and::before {
  content: "E";
}

.regra-section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.regra-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 10px;
  position: relative;
  margin-bottom: 16px;
}

.regra-dimensao {
  position: relative;
}

.regra-dimensao label {
  font-size: 11px;
  font-weight: 600;
  color: #555;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}

.field-hint-icon {
  position: relative;
  color: #aaa;
  cursor: help;
  font-size: 11px;
  display: inline-flex;
  align-items: center;
}

.field-hint-icon:hover {
  color: #0056b3;
}

.field-hint-icon::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  font-size: 11px;
  font-weight: normal;
  line-height: 1.5;
  padding: 6px 10px;
  border-radius: 4px;
  width: 240px;
  white-space: normal;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.1s ease;
  z-index: 9999;
}

.field-hint-icon:hover::after {
  opacity: 1;
}

.regra-dimensao select {
  font-size: 13px;
  border-radius: 6px;
  border: 1px solid #dddce9;
  padding: 6px 8px;
  width: 100%;
  background-color: #fff;
  transition: border-color 0.15s ease;
}

.regra-dimensao select:focus {
  border-color: #3a3e81;
  outline: none;
  box-shadow: 0 0 0 2px rgba(58, 62, 129, 0.1);
}

.regra-aplicacao-check {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.regra-aplicacao-check label {
  font-size: 12px;
  color: #555;
  cursor: pointer;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.regra-aplicacao-check input[type="checkbox"] {
  accent-color: #3a3e81;
}

.regra-divider {
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 14px 0;
}

.regra-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
  margin-top: 12px;
}

.regra-footer__desc-input {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #555;
}

.regra-footer__desc-input input {
  width: 64px;
  text-align: right;
  border: 1px solid #dddce9;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 13px;
  font-weight: 600;
}

.regra-footer__desc-input input:focus {
  border-color: #3a3e81;
  outline: none;
  box-shadow: 0 0 0 2px rgba(58, 62, 129, 0.1);
}

.regra-footer__delete {
  background: none;
  border: 1px solid #e4e7eb;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  color: #999;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.15s ease;
}

.regra-footer__delete:hover {
  border-color: #e74c3c;
  color: #e74c3c;
  background: #fef2f2;
}

.button-add-regra {
  background: none;
  border: 1px dashed #3a3e81;
  border-radius: 10px;
  padding: 10px 20px;
  color: #3a3e81;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  transition: all 0.15s ease;
}

.button-add-regra:hover {
  background: #f2f2f8;
}

.button-add-regra:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>

<template>
  <div>
    <div v-for="(regra, index) in campanha.dimensoes" :key="index">
      <div v-if="regra.tipoRegra === 'SEGMENTACAO'">
        <div
            v-if="validaRegraByDimensao(regra)"
            :class="{ 'regra-and': campanha.validarTodasRegras }"
            class="regra"
        >
          <div class="regra-section-label">Regra de validação</div>

          <div class="regra-container">
            <div v-for="dimensao in dimensoes" :key="'v-'+dimensao.coluna" class="regra-dimensao">
              <label>{{ dimensao.label }}</label>
              <select
                  v-model="regra[`dimensao${dimensao.coluna}`]"
                  @change="clonarRegra(regra)"
                  :disabled="campanha.erpId && campanha.id"
              >
                <option value="">—</option>
                <option
                    v-for="itemDimensao in dimensao.dimensoes"
                    :key="itemDimensao.id"
                    :value="itemDimensao.id"
                >
                  {{ itemDimensao.desc }}
                </option>
              </select>
            </div>
            <div class="regra-dimensao" v-if="inputRegraDimensaoShouldBeVisible">
              <label>
                Não compras
                <span
                  class="field-hint-icon ml-1"
                  data-tooltip="Permite definir um critério de não compra para este segmento. Quando configurado, a regra é aplicada apenas a produtos que nunca foram adquiridos pelo cliente ou que não foram comprados dentro do período selecionado."
                >
                  <fa-icon icon="info-circle" />
                </span>
              </label>
              <select
                  v-model="regra.dimensaoRegra"
                  @change="clonarRegra(regra)"
                  :disabled="campanha.erpId && campanha.id"
              >
                <option value="">—</option>
                <option
                  v-for="(regraCompraDesc, regraCompraIndex) in regraCompraNaoCompra"
                  :key="regraCompraIndex"
                  :value="regraCompraIndex"
                >
                  {{ regraCompraDesc }}
                </option>
              </select>
            </div>
          </div>

          <hr class="regra-divider" />

          <div class="regra-section-label">Regra de aplicação</div>
          <div class="regra-aplicacao-check">
            <label>
              <input
                  type="checkbox"
                  v-model="regra.aplicaregra"
                  :value="true"
                  @change="clonarRegra(regra)"
                  :disabled="campanha.erpId && campanha.id"
              />
              Aplicar o desconto nos mesmos itens da regra de validação
            </label>
          </div>

          <div class="regra-container">
            <div v-for="dimensao in dimensoes" :key="'a-'+dimensao.coluna" class="regra-dimensao">
              <label>{{ dimensao.label }}</label>
              <select
                  v-model="regra[`dimensaoaplicacao${dimensao.coluna}`]"
                  :disabled="!!regra.aplicaregra || (campanha.erpId && campanha.id)"
              >
                <option value="">—</option>
                <option
                    v-for="itemDimensao in dimensao.dimensoes"
                    :key="itemDimensao.id"
                    :value="itemDimensao.id"
                >
                  {{ itemDimensao.desc }}
                </option>
              </select>
            </div>
            <div class="regra-dimensao" v-if="inputRegraDimensaoShouldBeVisible">
              <label>
                Não compras
                <span
                  class="field-hint-icon ml-1"
                  data-tooltip="Permite definir um critério de não compra para este segmento. Quando configurado, a regra é aplicada apenas a produtos que nunca foram adquiridos pelo cliente ou que não foram comprados dentro do período selecionado."
                >
                  <fa-icon icon="info-circle" />
                </span>
              </label>
              <select
                  v-model="regra.dimensaoRegraAplicacao"
                  @change="clonarRegra(regra)"
                  :disabled="!!regra.aplicaregra || (campanha.erpId && campanha.id)"
              >
                <option value="">—</option>
                <option
                  v-for="(regraCompraDesc, regraCompraIndex) in regraCompraNaoCompra"
                  :key="regraCompraIndex"
                  :value="regraCompraIndex"
                >
                  {{ regraCompraDesc }}
                </option>
              </select>
            </div>
          </div>

          <div v-if="campanha.validarPorRegra">
            <TipoValidacao
                :item="regra"
                :inputShouldBeVisible="inputShouldBeVisible"
                :validacao="validacao"
                :disabled="campanha.erpId && campanha.id"
            />
          </div>

          <div class="regra-footer">
            <div class="regra-footer__desc-input">
              Desconto de
              <input
                  type="number"
                  min="0"
                  step="0.01"
                  v-model="regra.percDesc"
                  @keydown="['-', 'e', 'E', '+'].includes($event.key) && $event.preventDefault()"
                  :disabled="campanha.erpId && campanha.id"
              />
              % nos itens da regra de aplicação
            </div>
            <button
                type="button"
                class="regra-footer__delete"
                @click="excluirRegra(index)"
                :disabled="campanha.erpId && campanha.id"
            >
              <CIcon name="cil-trash" size="sm" /> Excluir
            </button>
          </div>
        </div>
      </div>
    </div>
    <button
        type="button"
        class="button-add-regra"
        @click="adicionarRegra"
        :disabled="campanha.erpId && campanha.id"
        v-if="computedShowAdicionarRegra"
    >
      + Adicionar Regra
    </button>
  </div>
</template>

<script>
import clone from "just-clone";
import _find from "lodash/find";
import TipoValidacao from "@/views/Campanhas/components/CampanhasComerciais/components/Regra/TipoValidacao.vue";

const initialDimensao = () => ({
  dimensao1: "",
  dimensao2: "",
  dimensao3: "",
  dimensao4: "",
  dimensao5: "",
  dimensao6: "",
  dimensao7: "",
  dimensao8: "",
  dimensao9: "",
  dimensao10: "",
  dimensaoaplicacao1: "",
  dimensaoaplicacao2: "",
  dimensaoaplicacao3: "",
  dimensaoaplicacao4: "",
  dimensaoaplicacao5: "",
  dimensaoaplicacao6: "",
  dimensaoaplicacao7: "",
  dimensaoaplicacao8: "",
  dimensaoaplicacao9: "",
  dimensaoaplicacao10: "",
  percDesc: 0,
  aplicaregra: true,
  qtdeMin: 0,
  qtdeMax: null,
  qtdeMinDistinta: 0,
  qtdeMaxDistinta: null,
  vlMin: 0,
  vlMax: 0,
  percMin: 0,
  percMax: 0,
  tipoRegra: 'SEGMENTACAO',
  regraDimensao: 'NUNCA_COMPRADO'
});

  export default {
    components: {TipoValidacao},
    props: ["campanha", "validacao", "dimensoes", "tiposInputs", "showAdicionarRegraButton"],
    data() {
      return {
        dimensao: initialDimensao()
      }
    },
    computed: {
      computedShowAdicionarRegra () {
        return this.showAdicionarRegraButton;
      },
      regraCompraNaoCompra() {
        return {
          NUNCA_COMPRADO: "Nunca comprado",
          NAO_COMPRADO_MES: "Não comprados no mês",
          NAO_COMPRADO_MES_PASSADO: "Não comprados mês passado",
          NAO_COMPRADO_MAIS_30_DIAS: "Não comprados há mais de 30 dias",
          NAO_COMPRADO_MAIS_45_DIAS: "Não comprados há mais de 45 dias",
          NAO_COMPRADO_MAIS_60_DIAS: "Não comprados há mais de 60 dias",
          NAO_COMPRADO_MAIS_90_DIAS: "Não comprados há mais de 90 dias",
          NAO_COMPRADO_MAIS_180_DIAS: "Não comprados há mais de 180 dias",
          NAO_COMPRADO_MAIS_365_DIAS: "Não comprados há mais de 365 dias",
        }
      },
      inputRegraDimensaoShouldBeVisible() {
        return this.campanha.usaNaoCompra;
      }
    },
    methods: {
      validaDimensao(dimensao, coluna) {
        if (dimensao == null || dimensao == "" || !dimensao) return true;
        var dimensoes = clone(this.dimensoes);

        const _dimensao = _find(this.dimensoes, (d) => d.coluna === coluna);

        if (!_dimensao) {
          return false;
        }

        var valida = false;
        _dimensao.dimensoes.forEach((e) => {
          if (e.id === dimensao) {
            valida = true;
          }
        });

        return valida;
      },
      adicionarRegra() {
        this.campanha.dimensoes.push(initialDimensao());
      },
      excluirRegra(index) {
        this.campanha.dimensoes.splice(index, 1);
      },
      clonarRegra(regra) {
        if (regra.aplicaregra) {
          for (let idx = 1; idx <= 11; idx++) {
            regra[`dimensaoaplicacao${idx}`] = regra[`dimensao${idx}`];
          }

          regra.dimensaoRegraAplicacao = regra.dimensaoRegra;
        }
      },
      validaRegraByDimensao(regra) {
        if (!this.validaDimensao(regra.dimensao1, 1)) return false;
        if (!this.validaDimensao(regra.dimensao2, 2)) return false;
        if (!this.validaDimensao(regra.dimensao3, 3)) return false;
        if (!this.validaDimensao(regra.dimensao4, 4)) return false;
        if (!this.validaDimensao(regra.dimensao5, 5)) return false;
        if (!this.validaDimensao(regra.dimensao6, 6)) return false;
        if (!this.validaDimensao(regra.dimensao7, 7)) return false;
        if (!this.validaDimensao(regra.dimensao8, 8)) return false;
        if (!this.validaDimensao(regra.dimensao9, 9)) return false;
        if (!this.validaDimensao(regra.dimensao10, 10)) return false;

        if (!this.validaDimensao(regra.dimensaoaplicacao1, 1)) return false;
        if (!this.validaDimensao(regra.dimensaoaplicacao2, 2)) return false;
        if (!this.validaDimensao(regra.dimensaoaplicacao3, 3)) return false;
        if (!this.validaDimensao(regra.dimensaoaplicacao4, 4)) return false;
        if (!this.validaDimensao(regra.dimensaoaplicacao5, 5)) return false;
        if (!this.validaDimensao(regra.dimensaoaplicacao6, 6)) return false;
        if (!this.validaDimensao(regra.dimensaoaplicacao7, 7)) return false;
        if (!this.validaDimensao(regra.dimensaoaplicacao8, 8)) return false;
        if (!this.validaDimensao(regra.dimensaoaplicacao9, 9)) return false;
        if (!this.validaDimensao(regra.dimensaoaplicacao10, 10)) return false;

        return true;
      },
      inputShouldBeVisible(inputName) {
        return (
            this.tiposInputs[this.campanha.validacao] &&
            this.tiposInputs[this.campanha.validacao].indexOf(inputName) >= 0
        );
      },
    }
  }
</script>
